import React, { useEffect } from "react";

import { Container, Accordion } from "react-bootstrap";

import { FAQList } from "../../../utility/content/FAQ";

import scrollToTop from "../../../libs/scrollToTop";

import {
  StyledSection,
  StyledMark,
  StyledAccordionItem,
} from "../../../style/base/styledPublicPages";

export default function FAQPageComponent() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <StyledSection>
      <Container className="mb-5">
        <h1 className="text-center mb-5">
          <StyledMark>سوالات متداول</StyledMark>
        </h1>
        {FAQList.map((item) => {
          return (
            <Accordion key={item.id} defaultActiveKey="0">
              <StyledAccordionItem eventKey={`${item.id - 1}`}>
                <Accordion.Header>{item.title}</Accordion.Header>
                <Accordion.Body className="text-muted">
                  {item.mainText}
                </Accordion.Body>
              </StyledAccordionItem>
            </Accordion>
          );
        })}
      </Container>
    </StyledSection>
  );
}
